import React from 'react'
// assests folder needs to be under src - Relative imports outside of src/ are not supported. Either would have to addd href and not import it
import CV from '../../assets/Syed Mohammad Gouse.pdf'
import { useRef } from 'react';

export default function CTA() {
  return (
    <div className='cta'>
      {/* <a href={CV} download className='btn nav-link resume' id="resume-link-2 resume-button-2" >Download Resume</a> */}
      {/* <a href="https://drive.google.com/uc?export=download&id=1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z" download="Syed-Mohammad-Gouse-Resume" 
       className='btn nav-link resume' id="resume-button-2" onClick={handleDownload}  >Download Resume</a> */}
       <a   href="https://drive.google.com/uc?export=download&id=1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z" onClick={handleDownload} rel="noreferrer" download={'Syed-Mohammad-Gouse-Resume'} id="resume-button-1" className="contact-button nav-link resume resume-button second-btn btn nav-link resume">Download Resume</a>
      <a href="#contact" className='btn btn-primary'>Reach out</a>
    </div>
  )
  function handleDownload () {
    window.open('https://drive.google.com/file/d/1EpEcm3vMvgizrbHQUMXNtKhwkExE1Q5Z/view', '_blank');
  };
}
